function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';
var colors = {
  blue: 'rgb(197,222,241)',
  green: 'rgb(191,236,226)',
  purple: 'rgb(184,188,219)'
};
var ColoredCard = styled.div.attrs({}).withConfig({
  displayName: "ColoredCard",
  componentId: "sc-1twtn03-0"
})(["padding:20px;background-color:", ";border-radius:10px;"], function (_ref) {
  var color = _ref.color;
  return colors[color];
});
var Header = styled.h4.withConfig({
  displayName: "ColoredCard__Header",
  componentId: "sc-1twtn03-1"
})([""]);
var Icon = styled(function (_ref2) {
  var className = _ref2.className,
      name = _ref2.name;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: name
  }));
}).withConfig({
  displayName: "ColoredCard__Icon",
  componentId: "sc-1twtn03-2"
})(["text-align:center;.fa{color:", ";font-size:", ";}"], function (props) {
  return props.color || 'white';
}, function (props) {
  return props.fontSize || '75px';
});

var HeaderWithIcon = function HeaderWithIcon(_ref3) {
  var className = _ref3.className,
      headerText = _ref3.headerText,
      iconColor = _ref3.iconColor,
      iconFontSize = _ref3.iconFontSize,
      iconName = _ref3.iconName,
      _ref3$iconStyle = _ref3.iconStyle,
      iconStyle = _ref3$iconStyle === void 0 ? {} : _ref3$iconStyle;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "3"
  }, /*#__PURE__*/React.createElement(Icon, {
    color: iconColor,
    fontSize: iconFontSize,
    name: iconName,
    style: iconStyle
  })), /*#__PURE__*/React.createElement(Col, {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("h4", null, headerText)));
}; // eslint-disable-next-line react/prop-types


var Body = function Body(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, children));
}; // eslint-disable-next-line react/prop-types


var ColoredCardButton = function ColoredCardButton(_ref5) {
  var children = _ref5.children,
      href = _ref5.href,
      rest = _objectWithoutProperties(_ref5, ["children", "href"]);

  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    color: "primary",
    href: href,
    size: "lg"
  }, rest), children))));
};

ColoredCard.Header = Header;
ColoredCard.HeaderWithIcon = HeaderWithIcon;
ColoredCard.Icon = Icon;
ColoredCard.Body = Body;
ColoredCard.Button = ColoredCardButton;
export default ColoredCard;